import { createImageFormData } from "./create-image-form-data"
import { makeApiRequest } from "./api-requester"

type UploadImageProps = {
  image: string
  name: string
  authToken: string
  collection?: string
}

export type UploadImageResponse = {
  doc: {
    id: string
  }
}

/**
 * Uploads an image to the CMS
 **/
export const uploadImage = async ({ image, name, collection, authToken }: UploadImageProps) => {
  const formData = await createImageFormData(image, name)
  const response = await makeApiRequest<UploadImageResponse>(`/api/${collection}`, {
    method: 'POST',
    headers: {
      'Authorization': `JWT ${authToken}`,
    },
    body: formData,
  })

  if (!response.doc.id) {
    throw new Error('An error occurred while uploading the image')
  }

  return response
}